import { Minute } from '@nu-art/ts-common';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_PathwayImport = {
    _v1: {
        validatePathway: { method: HttpMethod.POST, path: '/v1/pathway-import/validate', timeout: 5 * Minute },
        importPathway: { method: HttpMethod.POST, path: '/v1/pathway-import/import', timeout: 5 * Minute },
        attachHtml: { method: HttpMethod.POST, path: '/v1/pathway-import/attach-html', timeout: 5 * Minute },
    }
};
//# sourceMappingURL=apis-pathway-import.js.map